import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { injectIntl as withIntl } from 'react-intl';

import getShop from '@core/reducers/shop/selectors/getShop';
import getHasFetchedShop from '@core/reducers/shop/selectors/getHasFetchedShop';
import getSchedules from '@shopDetails/selectors/getSchedules';
import getNeedBromatologyCheck from '@core/reducers/shop/selectors/getNeedBromatologyCheck';
import { getTimeFormat } from '@shared/selectors';

const mapStateToProps = createStructuredSelector({
  hasFetchedShop: getHasFetchedShop,
  shop: getShop,
  schedules: getSchedules,
  needBromatologyCheck: getNeedBromatologyCheck,
  timeFormat: getTimeFormat,
});

const withConnect = connect(mapStateToProps);

export default compose(withRouter, withConnect, withIntl);
